import cx from 'classnames'
import { FocusTrap } from 'focus-trap-react'
import { type ReactNode, useEffect } from 'react'

import DrawerMenuBackdrop from '@components/drawer-menu/backdrop'
import DrawerMenuBackground from '@components/drawer-menu/background'

interface DrawerMenuProps {
  headerHeight: number
  activeDropdownHeight?: number
  isOpen: boolean
  hasFocus: boolean
  hasActiveLinks: boolean
  onClose: () => void
  children: ReactNode
  menuClassName?: string
  backgroundClassName?: string
  backdropClassName?: string
}

const DrawerMenu = ({
  headerHeight,
  activeDropdownHeight,
  isOpen,
  hasFocus,
  hasActiveLinks,
  onClose,
  children,
  menuClassName,
  backgroundClassName,
  backdropClassName,
}: DrawerMenuProps) => {
  useEffect(() => {
    document.body.classList.toggle('overflow-hidden', isOpen)
  }, [isOpen])

  return (
    <>
      <FocusTrap
        active={isOpen && hasFocus && hasActiveLinks}
        focusTrapOptions={{
          allowOutsideClick: true,
        }}
      >
        <div
          role="menu"
          tabIndex={-1}
          onKeyDown={({ key }) => {
            if (key === 'Escape') {
              onClose()
            }
          }}
          className={cx(
            'container absolute top-full inset-x-0 z-30 bg-pageBG',
            menuClassName
          )}
        >
          {children}
        </div>
      </FocusTrap>

      <DrawerMenuBackground
        height={isOpen ? headerHeight + (activeDropdownHeight ?? 0) : 0}
        className={backgroundClassName}
      />
      <DrawerMenuBackdrop
        isOpen={isOpen}
        onClose={onClose}
        className={backdropClassName}
      />
    </>
  )
}

export default DrawerMenu
